import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import { getMiToken, setLoginCookie, checkoutTokenCountry } from '@/utils/login'
import { globalVariable } from '@/utils/exportVariable'
import { region } from '@/utils/utils'
import { getUvid } from '@/utils/uvid'
import { getFid } from '@/utils/fid'
import { getFissionParams } from './fission'

function commonParams() {
  return {
    uvid: getUvid(),
    fid: getFid(),
    ...getFissionParams(),
  }
}

export const quickLogin = (options, type) => {
  options = {
    source: 1,
    ...options,
    ...commonParams(),
  }

  if (type !== 'vk') {
    return request.postJson({
      url: appendApiUrl('/user/login'),
      data: { ...deleteEmpty(options) },
    })
  } else {
    return loginVk(options)
  }
}

export const autoLogin = () => {
  const token = getMiToken()
  // 如果没有获取到token，或者href中的国家和token中的国家不同，则不自动登录
  if (!token || token === '' || !checkoutTokenCountry()) {
    return Promise.reject({ valid: false })
  }
  const { userInfo = {} } = globalVariable.store.state || {}
  if (userInfo && userInfo.kicoinId && userInfo.kicoinToken) {
    return Promise.resolve(userInfo)
  }
  const options = {
    country: region(),
  }
  return new Promise((resolve, reject) => {
    request
      .postJson(
        {
          url: appendApiUrl('/user/v1/login-status'),
          data: { ...deleteEmpty(options) },
        },
        {
          showLoading: false,
          showErrorToast: false,
        }
      )
      .then((response) => {
        if (!!response && typeof response === 'object') {
          response.loginTypeIsAuto = true
        }
        setLoginCookie(response, 'autoLogin')
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// vk 登录
export const loginVk = (options = {}) => {
  options = {
    ...options,
    ...getFissionParams('vk'),
  }
  return request.postJson(
    {
      url: appendApiUrl('/user/login/vk'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}
